<div *ngIf="brandId === BrandEnum.CELPIP">
    <div *ngIf="!selectedTestTypeId && pageTitle">
        <app-page-title [title]="pageTitle"></app-page-title>
        <div class="row mt-4">
            <div class="col-md-6 text-center">
                <div
                    class="testSelection"
                    [ngClass]="{'selected' : testTypeId==testTypeGId}"
                    (click)="selectTest(testTypeGId)"
                ><img
                        [src]="celpipGLogo"
                        alt="celpip-logo"
                    /></div>
                <div class="testSelectionDesc py-2">
                    <p>This is a <strong>four-skills</strong> (listening, reading, writing, and speaking) English language proficiency test used to assess functional language proficiency.</p>
                    <p *ngIf="!isWebDelivery">It is accepted by Immigration, Refugees and Citizenship Canada for <strong>permanent resident</strong> status and <strong>post-graduation work permit (PGWP)</strong> in Canada.</p>
                    <p *ngIf="isWebDelivery">CELPIP Online Test results are accepted by The College of Immigration and Citizenship Consultants (CICC). </p>
                    <p *ngIf="testTypeId===testTypeGId"><a
                            (click)="confirmSelectTest()"
                            class="btn btn-primary"
                        >Continue</a></p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <div
                    class="testSelection"
                    [ngClass]="{'selected' : testTypeId===testTypeLSId}"
                    (click)="selectTest(testTypeLSId)"
                ><img
                        [src]="celpipLSLogo"
                        alt="celpip-ls-logo"
                    /></div>
                <div class="testSelectionDesc py-2">
                    <p>This is a <strong>two-skills</strong> (listening and speaking) English language proficiency test used to assess functional language proficiency.</p>
                    <p *ngIf="!isWebDelivery">It is accepted by Immigration, Refugees and Citizenship Canada for <strong>Canadian citizenship</strong>.</p>
                    <p *ngIf="testTypeId===testTypeLSId"><a
                            (click)="confirmSelectTest()"
                            class="btn btn-primary"
                        >Continue</a></p>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="selectedTestTypeId">
        <app-page-title [title]="'What is the primary reason for taking this test?'"></app-page-title>
        <div class="form-group mt-4">
            <div *ngIf="selectedTestTypeId===testTypeGId && !isWebDelivery">If you intend to use your CELPIP results for more than one purpose and one of them is to apply for permanent residence, citizenship, or post-graduation work permit, please select Immigration, Refugees and Citizenship Canada (IRCC) as the purpose for taking the test. For post-graduation work permit, please select Permanent residence(PR)/Temporary residence(TR) in Canada under IRCC.</div>
        </div>
        <app-proof-of-identity-test-purpose
            [testPurposes]="testPurposes$ | async"
            [institutions]="institutions$ | async"
            [subscribedInstitutions]="subscribedInstitutions$ | async"
            [testTypeId]="testTypeId"
            [isWebDelivery]="isWebDelivery"
            (continue)="onContinue($event)"
        ></app-proof-of-identity-test-purpose>
    </div>
</div>
